<template>
  <session class="page-header">
    <div class="page-headerl">
      <div class="langs" @mouseenter="showoptions = true;" @mouseleave="showoptions = false">
        <Icon name="lang" /><span>{{curLang?.label}}</span>
        <div class="langlist-wrap" :class="{ showoptions: !!showoptions }">
          <div class="langlist">
            <div class="langitem" :class="{ active: curLang?.code == item?.code }" v-for="(item, index) in langList" :key="index" @click="selectLang(item)">
              <span>{{item?.label}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="items">
        <div class="item" @click="Utils.loginDialogToggle(true)"><Icon name="user" /></div>
        <div class="item" @click="Utils.loginDialogToggle(true,'person')"><Icon name="gift-b" size="38"/></div>
      </div>
    </div>
    <div class="page-headerr" @click="Utils.toTargetPage('/')">
      <img src="@/assets/images/logo-en.svg" v-if="!curLang?.code || curLang?.code == 'en'" />
      <img src="@/assets/images/logo.svg" v-if="curLang?.code == 'zh'" />
      <img src="@/assets/images/logo-jp.svg" v-if="curLang?.code == 'jp'" />
      <img src="@/assets/images/logo-kr.svg" v-if="curLang?.code == 'kr'" />
    </div>
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import Icon from '@/components/icon/index.vue';
  import * as Utils from '@/assets/utils';
  import { getLangList, getLocalLang, setLocalLangCode } from '@/assets/lang/index';

  /**
   * 多语言
   */
  const showoptions = ref(false);
  const langList = ref([])
  const curLang = ref(null);
  const init = () => {
    langList.value = getLangList();

    curLang.value = getLocalLang();
  }
  onMounted(() => {
    init();
  })
  const selectLang = data => {
    setLocalLangCode(data?.code);
    window.location.reload();
  }

  // 登录
  const showLogin = ref(false);
</script>

<style scoped lang="less">
  @import "index.less";
</style>
